import { ThemeColors } from "./theme.base";

export const devColors = {
  light: {
    primary: { main: "#3F51B5", light: "#7986CB", dark: "#283593" },
    secondary: { main: "#90CAF9" },
    background: {
      default: "#F4F6FA",
      paper: "#FFFFFF",
      custom: "#EEF1F7",
      body: "#F4F6FA",
    },
    text: { primary: "#1F2937", secondary: "#4B5563" },
    link: "#2563EB",
    highlightedRow: "#E8EEFF",
    borders: { appBar: "2px solid #90CAF9" },
    dataGrid: { header: "#EEF1F7" },
  },

  dark: {
    primary: { main: "#8FA3FF", light: "#B6C1FF", dark: "#5C6BC0" },
    secondary: { main: "#4FC3F7" },
    background: {
      default: "#0F172A",
      paper: "#111827",
      custom: "#1E293B",
      body: "#0F172A",
    },
    text: { primary: "#E5E7EB", secondary: "#9CA3AF" },
    link: "#60A5FA",
    highlightedRow: "#1E3A8A",
    borders: { appBar: "2px solid #4FC3F7" },
    dataGrid: { header: "#1E293B" },
  },
} satisfies Record<"light" | "dark", ThemeColors>;
